import { Expert } from "./expert.model";
import { Specialty } from "./specialty.model";
import { SubSpecialty } from "./sub-specialty.model";

export class Appointment {
    id: string;
    user_id: string;

    // Is urgent
    urgent: boolean;
    urgent_confirmed_timestamp?: string;
    urgent_reschedule_count: number = 0;
    urgent_confirmed?: boolean = false;
    urgent_notes?: string[] = [];

    // Patient info
    patient_last_name: string;
    patient_first_name: string;
    patient_id: string;

    // Expert info
    expert_first_name: string;
    expert_last_name: string;
    expert_id: string;

    // Doctor info
    doctor_first_name?: string;
    doctor_last_name?: string;
    doctor_id: string;

    // Reason for appointment
    chief_complaint: string;
    history_of_illness: string;
    relevant_labs?: string;

    // Specialty info
    specialty: Specialty;
    sub_specialty: SubSpecialty;

    // Organization
    org_location_id: string;
    org_location_name?: string;

    // Appointment info
    consultation: string[] = ['open'];
    confirmed: boolean = false;
    zoom_join?: string;
    zoom_start?: string;
    zoom_video_url?: string;
    zoom_meeting_id?: number;
    zoom_meeting_password?: string;
    is_custom_time: boolean = false;
    expert_request?: string[] = [];
    expectation?: boolean = null;
    date_string?: string;
    time_string?: string;
    info_requested?: boolean = false;
    rescheduled?: boolean = false;
    reschedule_requested?: boolean = false;
    canceled?: boolean = false;
    joined?: boolean;
    session_invites_sent: boolean = false;
    experts_invited: Expert[] = [];
    created_at?: string;
    updated_at?: string;
    expert_join_time: string = null;
    hospital_join_time: string = null;
    needs_confirmation_by?: string;
    messages: string[] = [];
    date_closed: string = null;
    consult_notes?: string;
    expert_notes?: string[] = [];
    general_consult_notes: string[];

    appointment_date: string;
    appointment_date_timestamp: string;
    appointment_date_id: string;

    review_addressed: boolean = false;
    received_requested_info?: boolean;

    expectation_resolved?: boolean = null;
    admin_resolution_notes?: string;

    // notifications
    new_lab: boolean = false;
    new_expert_message: boolean = false;
    new_doctor_message: boolean = false;

    // event links
    ics_event_string?: string;

    expert_google_event_link?: string;
    expert_yahoo_event_link?: string;
    expert_aol_event_link?: string;

    doctor_google_event_link?: string;
    doctor_yahoo_event_link?: string;
    doctor_aol_event_link?: string;
}